import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

export enum WizardId {
	createRule = "create-rule",
}
const data: Record<WizardId, Record<string, unknown>> = {
	[WizardId.createRule]: {},
};
const dataChanged: Record<WizardId, Record<string, BehaviorSubject<number>>> = {
	[WizardId.createRule]: {},
};
const disableNextButton: Record<WizardId, BehaviorSubject<boolean>> = {
	[WizardId.createRule]: new BehaviorSubject<boolean>(false),
};
const disableSaveButton: Record<WizardId, BehaviorSubject<boolean>> = {
	[WizardId.createRule]: new BehaviorSubject<boolean>(false),
};
const currentStep: Record<string, BehaviorSubject<number>> = {};

const saveButtonClicked: Record<WizardId, Subject<void>> = { [WizardId.createRule]: new Subject() };
const saveCompleted: Record<WizardId, Subject<void>> = { [WizardId.createRule]: new Subject() };
const wizardTitleChanged: Record<WizardId, Subject<string>> = { [WizardId.createRule]: new Subject() };

const hasError: Record<WizardId, BehaviorSubject<boolean>> = {
	[WizardId.createRule]: new BehaviorSubject<boolean>(false),
};
@Injectable({
	providedIn: "root",
})
export class WizardService {
	constructor() {}

	init(wizardId: WizardId) {
		currentStep[wizardId] = new BehaviorSubject(0);
		dataChanged[wizardId] = {};
	}

	setValue(wizardId: WizardId, key: string, value: any) {
		data[wizardId] = data[wizardId] || {};
		data[wizardId][key] = value;

		this.initDataChangedSubject(wizardId);

		dataChanged[wizardId][currentStep[wizardId].getValue()].next(
			dataChanged[wizardId][currentStep[wizardId].getValue()].getValue() + 1,
		);
	}

	getValue(wizardId: WizardId, key: string) {
		return data[wizardId][key];
	}

	clear(wizardId: WizardId) {
		data[wizardId] = {};
		hasError[wizardId].next(false);
		dataChanged[wizardId] = {};
		currentStep[wizardId].next(0);
	}

	setCurrentStep(wizardId: WizardId, step: number) {
		currentStep[wizardId].next(step);
	}

	incrementCurrentStep(wizardId: WizardId) {
		currentStep[wizardId].next(currentStep[wizardId].getValue() + 1);
	}

	decrementCurrentStep(wizardId: WizardId) {
		currentStep[wizardId].next(currentStep[wizardId].getValue() - 1);
	}

	disableSaveButton(wizardId: WizardId) {
		disableSaveButton[wizardId].next(true);
	}
	enableSaveButton(wizardId: WizardId) {
		disableSaveButton[wizardId].next(false);
	}
	disableNextButton(wizardId: WizardId) {
		disableNextButton[wizardId].next(true);
	}
	enableNextButton(wizardId: WizardId) {
		disableNextButton[wizardId].next(false);
	}
	saveButtonClicked(wizardId: WizardId) {
		saveButtonClicked[wizardId].next();
	}
	saveCompleted(wizardId: WizardId) {
		saveCompleted[wizardId].next();
	}
	setHasError(wizardId: WizardId) {
		hasError[wizardId].next(true);
	}
	setWizardTitle(title: string, wizardId: WizardId) {
		wizardTitleChanged[wizardId].next(title);
	}
	getHasError(wizardId: WizardId) {
		return hasError[wizardId].getValue();
	}

	initDataChangedSubject(wizardId: WizardId) {
		dataChanged[wizardId][currentStep[wizardId].getValue()] =
			dataChanged[wizardId][currentStep[wizardId].getValue()] || new BehaviorSubject<number>(0);
	}
	listenToStepChanges(wizardId: WizardId) {
		return currentStep[wizardId].asObservable();
	}

	listenToDataChanges(wizardId: WizardId) {
		dataChanged[wizardId][currentStep[wizardId].getValue()] =
			dataChanged[wizardId][currentStep[wizardId].getValue()] || new BehaviorSubject<number>(0);
		return dataChanged[wizardId][currentStep[wizardId].getValue()].asObservable();
	}
	listenToDisableNextButton(wizardId: WizardId) {
		return disableNextButton[wizardId].asObservable();
	}
	listenToDisableSaveButton(wizardId: WizardId) {
		return disableSaveButton[wizardId].asObservable();
	}
	listenToSaveButtonClicked(wizardId: WizardId) {
		return saveButtonClicked[wizardId].asObservable();
	}
	listenToSaveCompleted(wizardId: WizardId) {
		return saveCompleted[wizardId].asObservable();
	}
	listenToHasError(wizardId: WizardId) {
		return hasError[wizardId].asObservable();
	}
	listenToWizardTitleChange(wizardId: WizardId) {
		return wizardTitleChanged[wizardId].asObservable();
	}
}
